import React from 'react';
import { stateOptions } from '../commonStateTaxData';

export const basicInfoQuestions = [
  {
    id: 'employee_first_name_middle_initial',
    title: 'First name and middle initial',
    question_type: 'short_text',
    is_required: true,
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const allowanceRateQuestion = [
  {
    id: 'allowance_rate',
    title: 'Allowance rate',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single filer, or if you are married and your spouse has income',
      },
      {
        codeValue: 'joint',
        shortName: 'Married and your spouse does not work',
      },
    ],
  },
];

export const allowanceRateQuestion2025 = [
  {
    id: 'allowance_rate',
    title: 'Allowance rate',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single filer, or if you are married and your spouse has income',
      },
      {
        codeValue: 'joint',
        shortName: 'Married and your spouse does not have income',
      },
    ],
  },
];

// Version 2025 Onwards
export const allowanceAndWithholdingQuestions = [
  {
    id: 'total_num_allowances',
    title: (
      <div>
        Total number of allowances you are claiming
        {' '}
        <a href="https://check-api-static-production.s3.amazonaws.com/forms/pdf/ks_k4_01.pdf" target="_blank" rel="noopener noreferrer">
          (from Line F above)
        </a>
      </div>
    ),
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_amt_withheld',
    title: 'Enter any additional amount you want withheld from each paycheck (this is optional)',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export const personalAllowanceWorksheetQuestions = [
  {
    id: 'personal_allowances',
    title: 'Check all that apply:',
    is_required: false,
    question_type: 'long_multiple_selection',
    options: [
      {
        codeValue: 'cannot_be_claimed_as_dependent',
        shortName: 'Select this box if you are married or single and no one else can claim you as a dependent',
      },
      {
        codeValue: 'married_one_job',
        shortName: 'Select this box if you are married and only have one job, and your spouse does not work',
      },
      {
        codeValue: 'head_of_household',
        shortName: 'Select this box if you will file head of household on your tax return',
      },
    ],
  },
];

export const personalAllowancesWorksheetQuestionsPt2 = [
  {
    id: 'dependents',
    title:
      'Enter the number of dependents you will claim on your tax return. Do not claim yourself or your spouse or dependents that your spouse has already claimed on their form K-4',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_amt_withheld',
    title: 'Enter any additional amount you want withheld from each paycheck',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
